import * as React from "react";
import { Component } from "react";
import { style } from "typestyle";
import { layout } from "./layout.js";
import { typography } from "./typography.js";
import { classNames } from "./utils.js";
import { View, ViewContent } from "./view.js";
const messageStyle = style({
    maxWidth: "15em",
    alignSelf: "center",
});
export class PendingView extends Component {
    render() {
        return (React.createElement(View, null,
            React.createElement(ViewContent, { className: classNames(layout.vertical, layout.center) },
                React.createElement("div", { className: classNames(typography.title, typography.alignCenter, messageStyle) }, this.props.message))));
    }
}
//# sourceMappingURL=PendingView.js.map